/* DownloadAction.js */

"use strict";
// const _ = require("lodash");

class DownloadAction {
    constructor(logger, gameEditor, activeView, OsUpgradePlan, userSession, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._OsUpgradePlanDef = OsUpgradePlan;
        this._activeOrgId = userSession.activeOrganization.id;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }

    async run() {
        console.log("Download plan...");
    }
}
module.exports = DownloadAction;

DownloadAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.entities.OdmOsUpgradePlan", // Changed from OdmOsUpdatePlan
    "$teve.userSession",
    "$teve.io",
];

DownloadAction.$displayDetails = {
    type: "Action",
    name: "DownloadAction",
    icon: "configdrift.export_devices",
    shown: false,
    title: "Download IoT OS Plan",
    order: 5,
};
